import { useState } from "react";
import {
  Button,
  Form,
  Container,
  Row,
  Col,
  Alert,
  Spinner,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import React from "react";

const DeleteDashboardData = () => {
  const [email, setEmail] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleDelete = async () => {
    if (!email.trim()) {
      setResult({ type: "danger", message: "Please enter an email." });
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      const res = await axios.post(
        "https://admin.riameets.com/deleteDashboardTilesOnly",
        { email },
      );

      const data = res.data;

      setResult({
        type: "success",
        message: `
${data.message || "User cleanup completed."}
Mongo Deleted From Collections: ${data.mongoDeletedFromCollections ?? 0}
        `,
      });
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        "An error occurred while deleting the user.";
      setResult({ type: "danger", message: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: "100vh", padding: "20px" }}
    >
      {/* Back Button */}
      <Button
        className="sticky-back-button my-2"
        onClick={() => navigate("/")}
        style={{ backgroundColor: "rgb(72, 39, 110)" }}
      >
        Back
      </Button>

      {/* Delete User Form */}
      <Row className="w-100 justify-content-center">
        <Col xs={12} sm={10} md={6} lg={4}>
          <div
            className="p-4 shadow-sm rounded"
            style={{
              backgroundColor: "white",
              border: "1px solid #e0e0e0",
            }}
          >
            <h5
              className="text-center mb-4"
              style={{ color: "rgb(72, 39, 110)" }}
            >
              Delete User by Email
            </h5>

            <Form.Group controlId="emailInput" className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter user's email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoCapitalize="none"
                autoCorrect="off"
                inputMode="email"
              />
            </Form.Group>

            <div className="d-grid">
              <Button
                onClick={handleDelete}
                style={{
                  backgroundColor: "rgb(72, 39, 110)",
                  border: "none",
                }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Deleting...
                  </>
                ) : (
                  "Delete User"
                )}
              </Button>
            </div>

            {result && (
              <Alert
                variant={result.type}
                className="mt-3"
                style={{ fontSize: "0.9rem" }}
              >
                <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                  {result.message}
                </pre>
              </Alert>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default DeleteDashboardData;
